import React, { useState, useContext } from 'react'
import i18n from 'live/services/i18n'
import { clearSessionToken, getAutocomplete, getPlaceDetails } from '../../api/google-integration'
import InputSearch from '../InputSearchAutocomplete/InputSearchAutocomplete'
import TripsChart from '../TripsChart/index'
import TripsContext from '../../contexts/TripsContext'
import { useMarkers } from '../../hooks/useMarker'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'

const GoogleAutocomplete = () => {
    const { setCenterMap } = useContext(TripsContext)
    const [value, setValue] = useState<any>()
    const [markers, setMarkers] = useState<any>()
    const [suggestions, setSuggestions] = useState<any>([])

    const handleSelect = ({ description, placeId }) => () => {
        setValue(description)
        setSuggestions([])

        getPlaceDetails(placeId).then((response: any) => {
            const marker = createMarker(response.data)
            const { lat, lng } = marker
            setMarkers({ markers: [marker] })
            setCenterMap({ lat, lng })
            clearSessionToken()
        })
    }

    const createMarker = ele => {
        const {
            geometry: { location }
        } = ele

        const marker = {
            icon: {
                path: faMapMarkerAlt.icon[4] as string,
                fillColor: '#D9534F',
                fillOpacity: 1,
                anchor: new google.maps.Point(
                    faMapMarkerAlt.icon[0] / 2, // width
                    faMapMarkerAlt.icon[1] / 2 // height
                ),
                strokeWeight: 1.5,
                strokeColor: '#ffffff',
                scale: 0.075
            },
            lat: location?.lat,
            lng: location?.lng
        }

        return marker
    }

    const search = (query: string) => {
        if (query === '') {
            return setMarkers([])
        }

        getAutocomplete(query)
            .then(response => {
                const suggestions = response.data.map(ele => {
                    const {
                        structuredFormatting: { mainText, secondaryText }
                    } = ele

                    ele.mainText = mainText
                    ele.secondaryText = secondaryText
                    ele.value = ele
                    ele.onClick = handleSelect

                    return ele
                })

                setSuggestions(suggestions)
            })
            .catch(error => {
                setSuggestions([])
            })
    }

    useMarkers(markers)

    return (
        <div style={{ width: 400, position: "relative", zIndex: 100 }}>
            <InputSearch
                value={value}
                suggestions={suggestions}
                onSearch={search}
                placeholder={i18n('Search by address...')}
            />

            {value && (
                <div className="input-search-clear-container">
                    {/* <i className="fas fa-search fa-flip-horizontal"></i> */}
                    {/* <i className="fas fa-times" onClick={() => search('')}></i> */}
                </div>
            )}
        </div>
    )
}

export default React.memo(GoogleAutocomplete)
